/**
 * ModalMagazine.js
 * Controla a visibilidade do modal da revista quando o usuário clica na imagem de capa.
 */
document.addEventListener('DOMContentLoaded', () => {
  const sidebarCoverImage = document.querySelectorAll('.SidebarCoverImage');
  const modalMagazine = document.querySelectorAll('.ModalMagazine');
  const mainWrap = document.querySelector('.MainWrap');
  const closeButton = document.querySelectorAll('.ModalMagazine-close');

  sidebarCoverImage.forEach((el) => {
    el?.addEventListener('click', () => {
      el.nextElementSibling.classList.add('ModalMagazine-active');

      mainWrap.classList.add('MainWrap-active');
      document.body.style.overflow = 'hidden';
    });
  })

  closeButton.forEach((el) => {
    el?.addEventListener('click', () => {
      el.parentElement.parentElement.classList.remove('ModalMagazine-active');
      mainWrap.classList.remove('MainWrap-active');
      document.body.style.overflow = '';
    });
  })

  modalMagazine.forEach((el) => {
    el?.addEventListener('click', (event) => {
      if (event.target === el) {
        el.classList.remove('ModalMagazine-active');
        mainWrap.classList.remove('MainWrap-active');
        document.body.style.overflow = '';
      }
    });
  })
});
